import { Component, Element, Prop, Event, EventEmitter, Method, State, h, Host } from '@stencil/core';
import { getEventMessage, getLogLevel, LogLevel, Qualify, ReportEvent } from '@larva.io/report-definitions';
import ReportHelpers from './report-codes-helper';
import { LogEntry, InputMessage } from './log-interface';
import moment from 'moment';

import pick from 'lodash-es/pick';
import omit from 'lodash-es/omit';
import values from 'lodash-es/values';
import orderBy from 'lodash-es/orderBy';
import { config } from '../../../global/config';

@Component({
  tag: 'lar-log-modal',
  styleUrl: 'log-modal.scss',
  shadow: true
})
export class LogModal {
  private config = config;
  @Prop() modal?: HTMLLarModalElement
  /**
   * Larva sub-components request event
   */
  @Event() request!: EventEmitter;

  /**
   * Larva sub-components request event
   */
  @State() logreceived: boolean = false;
  /**
   * Larva sub-components request event
   */
  @State() logdata: LogEntry[] = [];

  private logcount: number = 0;
  /**
   * Request response method
   */
  @Method()
  async response(data: InputMessage) {
    if (this.modal) {
      this.modal.setAttribute('icon-small', '');
    }
    this.logreceived = true;
    this.logdata = data.logs;
    this.logcount = data.count;
  }

  componentDidLoad() {
    this.request.emit(); // request logs
  }
  /**
   * Display Larva Error
   */
  @Method()
  async error(data: any, timeout: number = 5000) {
    this.logreceived = true;
    let msg = 'error_messages.';
    if (typeof data === 'string') {
      msg += data;
    } else if (data && data.message && typeof data.message === 'string') {
      msg += data.message;
    } else {
      msg += 'UNKNOWN_ERROR';
    }
    const translate = <lar-translate t={msg} />;
    // this.notify.create(translate, 'danger', timeout); // @TODO: error notify
  }

  // @ts-ignore
  public static parseData(data: any, eventCode: number) {
    let ret = {};
    if (data && ReportHelpers.isSecurityEvent(eventCode)) { // alarm zone info
      ret = pick(data, ['name', 'sn', 'io', 'state', 'zone']);
    } else {
      ret = omit(data, ['user', 'flow'])
    }
    return values(ret).toString();
  }

  renderLogList() {
    const logs: any[] = [];
    const logdata = orderBy(this.logdata, 'createdAt', 'desc');
    const formatDateTime = this.config.get('formatDateTime', 'DD.MM.YYYY HH:mm');

    if (logdata.length === 0) {
      logs.push(<lar-list-header><lar-translate t="log.nologs" /></lar-list-header>)
      return logs;
    }

    let prevMonth: number;
    let prevYear: number;

    logdata.forEach(logitem => {
      let color = 'tertiary';
      let icon = 'info';
      const date = moment(new Date(logitem.createdAt));
      const month = date.month() + 1;
      const year = date.year();
      const code = Number(logitem.code);
      const logLevel = getLogLevel(code) as LogLevel;
      const message = getEventMessage(code);
      const qualify = Number(logitem.qualify);
      if (prevMonth !== month || prevYear !== year) {
        logs.push(
          <lar-list-header>
            <lar-translate t={'date.months.' + month} /> {year}
          </lar-list-header>
        );
        prevMonth = month;
        prevYear = year;
      }
      if (logLevel === LogLevel.ERROR) {
        color = 'danger';
      } else if (logLevel === LogLevel.WARNING) {
        color = 'warning';
      }
      // if issue is resolved issue, change color to green
      if (qualify === Qualify.RESTORE) {
        color = 'success';
      }
      if (ReportHelpers.isUserEvent(code)) {
        icon = 'user';
      } else if (ReportHelpers.isSecurityEvent(code)) {
        icon = 'warning';
        if (ReportHelpers.isFireAlarm(code)) {
          icon = 'fire_alarm';
        }
        if (ReportHelpers.isMedicalAlarm(code)) {
          icon = 'medical_alarm';
        }
        if (ReportHelpers.isPanicAlarm(code)) {
          icon = 'panic_alarm';
        }
        if (ReportHelpers.isOtherAreaAlarm(code)) {
          icon = 'other_alarm';
        }
      } else if (ReportHelpers.isCloudEvent(code)) {
        icon = 'cloud';
      } else if (ReportHelpers.isSystemEvent(code)) {
        icon = 'device';
      }

      logs.push(
        <lar-list-item>
          <div slot="start" class="circle">
            <lar-icon icon={icon} color={color} />
          </div>
          <div>
           <div class="date"><small>{moment(new Date(logitem.createdAt)).format(formatDateTime)}</small></div>
            <h4>
              <lar-translate t={'log_entries.' + code} fallback={message} />
            </h4>
            <div>
              {logitem.data && logitem.data.user &&
                <small>{logitem.data.user.firstname} {logitem.data.user.lastname}</small>
              }
            </div>
            {logitem.data &&
             <div>
              <small>{LogModal.parseData(logitem.data, code)}</small>
             </div>
            }
            {qualify === Qualify.RESTORE &&
              <div>
                <small>
                <lar-badge color="success">
                   {code === ReportEvent.SECURITY_PARTIAL_ARMED_DISARMED || code === ReportEvent.SECURITY_ARMED_DISARMED
                     ? // if arm arm/disarm event then NEW = disrarm, RESTORE = arm
                      <lar-translate t="log.armed" />
                     :
                      <lar-translate t="log.resolved" />
                   }
                </lar-badge>
                </small>
              </div>
            }
          </div>
        </lar-list-item>
      );
    });

    return logs;
  }

  render() {
    return [
      <div>
        {this.logreceived &&
          <lar-list>
            {this.renderLogList()}
          </lar-list>
        }
      </div>
    ];
  }
}
